import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=30f45b0f&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=30f45b0f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f45b0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30f45b0f')) {
      api.createRecord('30f45b0f', component.options)
    } else {
      api.reload('30f45b0f', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=30f45b0f&scoped=true", function () {
      api.rerender('30f45b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/SideMenu.vue"
export default component.exports